import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function BatteryEpoch({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Epoch battery</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}{d.frequency && <> - {formatValue(d.frequency, 1)} Hz</>}
          <p style={{ marginLeft: '1em' }}>
            SoC: {formatValue(d.soc)}%<br />
            Current: {formatValue(d.current)} A
          </p>
        </div>
      ))}
    </Item>
  );
}
